import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import BoxContent from "shared/ui/BoxContent";
import PageTitle from "shared/ui/PageTitle";
import {useLocation} from "react-router-dom";

type LocationProps = {
    state: {
        mode: number;
    };
};

const TestFinished = () => {
    const location = useLocation() as unknown as LocationProps;

    const mode = location.state?.mode || "";

    return (
        <Box component="main">
            {mode === 1 && (
                <>
                    <PageTitle back={true} url={"/teste/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Raportul BRIO și răspunsurile tale sunt disponibile în pagina <b>Teste școlare</b>,
                            secțiunea <b>Teste finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>
            )}
            {mode === 2 && (
                <>
                    <PageTitle back={true} url={"/teste-antrenament/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Răspunsurile tale sunt disponibile în pagina <b>Teste antrenament</b>, secțiunea <b>Teste
                            finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>
            )}
            {mode === 3 && (
                <>
                    <PageTitle back={true} url={"/teste-bac/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Raportul BRIO și răspunsurile tale sunt disponibile în pagina <b>Teste pregătire BAC</b>,
                            secțiunea <b>Teste finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>

            )}
            {mode === 4 && (
                <>
                    <PageTitle back={true} url={"/teste-evaluare/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Raportul BRIO și răspunsurile tale sunt disponibile în pagina <b>Teste pregătire Evaluare
                            Națională</b>, secțiunea <b>Teste finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>

            )}
            {mode === 5 && (
                <>
                    <PageTitle back={true} url={"/teste-literatie/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Raportul BRIO și răspunsurile tale sunt disponibile în pagina <b>Teste literație</b>,
                            secțiunea <b>Teste finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>

            )}
            {mode === 6 && (
                <>
                    <PageTitle back={true} url={"/teste-literatie-digitala/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Raportul BRIO și răspunsurile tale sunt disponibile în pagina <b>Teste literație
                            digitală</b>, secțiunea <b>Teste finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>
            )}
            {mode === 7 && (
                <>
                    <PageTitle back={true} url={"/teste-proprii/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Răspunsurile tale sunt disponibile în pagina <b>Teste proprii</b>, secțiunea <b>Teste
                            finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>

            )}

            {mode === 8 && (
                <>
                    <PageTitle back={true} url={"/teste-literatie-numerica/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Raportul BRIO și răspunsurile tale sunt disponibile în pagina <b>Teste de literație
                            numerică</b>, secțiunea <b>Teste finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>

            )}

            {mode === 9 && (
                <>
                    <PageTitle back={true} url={"/teste-literatie-stiintifica/teste-finalizate"}>
                        Felicitări, ai terminat testul!
                    </PageTitle>
                    <BoxContent>
                        <Typography>
                            Răspunsurile tale sunt disponibile în pagina <b>Teste de literație
                            științifică</b>, secțiunea <b>Teste finalizate</b>.
                        </Typography>
                    </BoxContent>
                </>

            )}
        </Box>
    );
};

export default TestFinished;
